<template>
  <span :class="classes" @click="onClick">
    <slot></slot>
  </span>
</template>
<script>
export default {
  name: "bx-btn",
  props: {
    color: {
      type: String,
      default: "default"
    },
    big: {
      type: Boolean,
      default: false
    },
    block: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes() {
      const classes = ["bx-btn"];

      classes.push(`btn-color-${this.color}`);

      if (this.big) {
        classes.push(`btn-big`);
      }

      if (this.block) {
        classes.push(`btn-block`);
      }

      return classes;
    }
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  }
};
</script>
